import type {
	RadioOption,
	Option,
} from '@atlassian/jira-issue-field-radio-select/src/ui/edit/types.tsx';

export const transformDefaultValue = ({ id, value }: RadioOption): Option => ({
	label: value,
	value: id,
});
